(() => {
  'use strict';
  const footer = document.querySelector('[data-vh-footer-language]');
  if (!footer) return;
  const form = footer.querySelector('form');
  const language = footer.querySelector('[data-vh-localization-language]');
  if (!form || !language) return;
  const readLocales = selector => { try { return JSON.parse(footer.querySelector(selector)?.textContent || '[]'); } catch { return []; } };
  const nativeLanguages = readLocales('[data-vh-native-languages]');
  const publishedLanguages = readLocales('[data-vh-published-languages]');
  const draft = footer.dataset.draft === 'true';
  const canonical = code => /^de-ch$/i.test(code) ? 'de' : code;
  const published = new Set(publishedLanguages.map(code => canonical(code).toLowerCase()));
  const possible = nativeLanguages.filter(code => published.has(canonical(code).toLowerCase()));
  const allowedDraft = new Set(['en', 'es', 'fr', 'de', 'nl', 'it', 'pt-PT']);
  const reviewBar = document.querySelector('.vh-draft-review');
  if (reviewBar) reviewBar.hidden = new URL(location.href).searchParams.get('vh_qa') !== '1';
  const switchLanguage = event => {
    event.preventDefault();
    const desired = canonical(language.value);
    const desiredNative = possible.find(code => canonical(code).toLowerCase() === desired.toLowerCase());
    const next = new URL(location.href);
    if (draft) {
      if (!/^\d+$/.test(footer.dataset.previewTheme) || !allowedDraft.has(desired)) return;
      next.searchParams.set('preview_theme_id', footer.dataset.previewTheme);
      if (desired === 'en') next.searchParams.delete('view'); else next.searchParams.set('view', `vh-lang-${desired}`);
      try { if (desired === 'en') sessionStorage.removeItem('vh_draft_cart_view'); else sessionStorage.setItem('vh_draft_cart_view', `vh-lang-${desired}`); } catch {}
    } else {
      if (!desiredNative) return;
      next.searchParams.delete('view');
    }
    if (draft && (!desiredNative || desiredNative === footer.dataset.nativeLocale)) {
      language.disabled = true;
      location.assign(next.href);
      return;
    }
    if (!draft && desiredNative === footer.dataset.nativeLocale) return;
    language.value = desiredNative;
    form.querySelectorAll('[name="return_to"]').forEach(input => { input.value = next.pathname + next.search + next.hash; });
    HTMLFormElement.prototype.submit.call(form);
  };
  language.addEventListener('change', switchLanguage);
  form.addEventListener('submit', switchLanguage);
})();
